<template>
  <div class="comment">
    <div class="avatar pull-left"><i class="fa fa-comment"></i></div>
    <div class="comment-content">
      <div class="heading">
        <span class="originator">We commented</span>
        <span class="time pull-right">{{ datetime | moment('from', 'now') }}</span>
      </div>
      <div class="message-content">{{ message }}</div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: 'MessageComment',
  props: {
    datetime: {
      type: Object,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    interval: null,
  }),
  created() {
    this.interval = setInterval(() => this.$forceUpdate(), 60000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';
.avatar {
  margin-right: 15px;
  font-size: 24px;
  color: lighten($colony-primary, 5%);
}

.comment:first-child {
  border-top: none;
}
.comment {
  padding-top: 8px;
  color: #676a6c;
  font-size: 0.9em;

  .originator {
    font-size: 12px;
    font-weight: bold;
    color: $colony-primary;
  }

  .comment-content {
    display: block;
    overflow: hidden;
  }
}
.time {
  margin-top: 3px;
  font-size: 11px;
  color: #90949c;
}
</style>



// WEBPACK FOOTER //
// MessageComment.vue?236ea521